import React, { useRef, useEffect, useMemo } from "react";
import JsBarcode from "jsbarcode";
const CustomBarcode = (props) => {
  const { value, ...otherProps } = props;
  const barcode = useRef(null);

  const option = useMemo(() => otherProps, [otherProps]);

  useEffect(() => {
    if (value && barcode.current) {
      JsBarcode(barcode.current, value, option);
    }
  }, [option, value]);

  return <svg ref={barcode}></svg>;
};

export default CustomBarcode;
//https://github.com/lindell/JsBarcode/wiki/Options
